import SolAPIError from './SolAPIError';

export type TanStackFieldErrors = Record<string, { message: string }[]>;

export const toTanStackFormFieldErrors = (error: unknown) => {
  if (!(error instanceof SolAPIError)) {
    return undefined;
  }

  const fieldErrors: TanStackFieldErrors = {};

  Object.values(error.errors).forEach((solError) => {
    const fieldName = solError.extensions.details?.fieldName;

    if (!fieldName) {
      return;
    }

    fieldErrors[fieldName] = [...(fieldErrors[fieldName] ?? []), { message: solError.message }];
  });

  if (Object.keys(fieldErrors).length === 0) {
    return undefined;
  }

  return { fields: fieldErrors };
};
